import { Select } from 'antd';
import { useFieldDefaults } from './defaults';

const FALLBACK = [
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'guardian', label: 'Guardian' },
];

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  status?: 'error' | 'warning';
  id?: string;
}

export function RelationField({ value, onChange, ...rest }: Props) {
  const defaults = useFieldDefaults();
  const options = defaults.relation?.options ?? FALLBACK;
  return (
    <Select
      value={value}
      onChange={(v) => onChange?.(v)}
      options={options as unknown as { value: string; label: string }[]}
      placeholder={rest.placeholder ?? 'Relation'}
      disabled={rest.disabled}
      status={rest.status}
      id={rest.id}
    />
  );
}
